/**
 * Where the front-end logger sits under an environment's API root.
 *
 * `userSettingsService` ends in a slash in every configuration, so this is
 * appended as-is.
 */
export const LOGGING_ENDPOINT_PATH = 'FrontEndLogger/LogError';
